module.exports = __webpack_public_path__ + "static/media/m2.663e92d9.png";